import React from 'react';
import { Lock, Zap, ShieldCheck, Smartphone, Download, Flame, Star, Crown } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
export function OfferSection() {
  const items = [{
    emoji: '📘',
    title: 'MegaPack Mecánica Básica para No Mecánicos',
    subtitle: '6 Tomos Completos',
    price: '$24.990',
    highlight: true
  }, {
    emoji: '🚗',
    title: 'Bono 1',
    subtitle: 'Guía Visual de Luces del Tablero',
    price: '$4.990'
  }, {
    emoji: '📋',
    title: 'Bono 2',
    subtitle: 'Checklist Previaje Imprimible',
    price: '$3.990'
  }, {
    emoji: '📄',
    title: 'Bono 3',
    subtitle: 'Plantillas para Pedir Presupuestos',
    price: '$4.990'
  }, {
    emoji: '💰',
    title: 'Bono 4',
    subtitle: 'Guía de Costos de Reparaciones Comunes',
    price: '$4.990'
  }, {
    emoji: '🧰',
    title: 'Bono 5',
    subtitle: 'Kit de Emergencias del Automóvil',
    price: '$4.990'
  }, {
    emoji: '🚘',
    title: 'Bono 6',
    subtitle: 'Manual Express para Comprar Autos Usados',
    price: '$4.990'
  }];
  return <section id="oferta" className="py-8 md:py-12 bg-[#171717] border-b border-[#262626]" data-id="element-156">
      <div className="max-w-xl mx-auto px-4 md:px-6" data-id="element-157">
        <SectionReveal className="text-center mb-4" data-id="element-158">
          <div className="inline-flex items-center gap-2 text-[#F59E0B] font-heading font-bold text-xs md:text-sm tracking-widest" data-id="element-159">
            <span className="text-lg" data-id="element-160">💰</span>
            OFERTA ESPECIAL DE LANZAMIENTO
          </div>
        </SectionReveal>

        <SectionReveal delay={0.1} data-id="element-161">
          <div className="bg-[#0a0a0a] border-2 border-[#F59E0B] rounded-sm shadow-[0_0_60px_rgba(245,158,11,0.2)] relative" data-id="element-162">
            {/* "Most chosen" ribbon */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#F59E0B] to-[#D97706] text-[#0a0a0a] font-heading font-bold text-[10px] md:text-xs tracking-widest px-4 py-1 rounded-sm whitespace-nowrap flex items-center gap-1.5 shadow-lg" data-id="element-163">
              <Star className="w-3 h-3 fill-current" data-id="element-164" />
              LA OPCIÓN MÁS ELEGIDA
              <Star className="w-3 h-3 fill-current" data-id="element-165" />
            </div>

            <div className="p-4 md:p-5 pt-7 md:pt-8" data-id="element-166">
              <h2 className="font-heading text-center text-base md:text-lg font-bold text-white mb-3 tracking-wide" data-id="element-167">
                Todo lo que recibís hoy:
              </h2>

              {/* Itemized list */}
              <div className="space-y-1.5 mb-4" data-id="element-168">
                {items.map((item, idx) => <div key={idx} className={`flex items-center gap-2 p-2 rounded-sm border ${item.highlight ? 'bg-[#F59E0B]/5 border-[#F59E0B]/40' : 'bg-[#171717] border-[#262626]'}`} data-id="element-169">
                    <div className="text-base md:text-lg flex-shrink-0" data-id="element-170">
                      {item.emoji}
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-171">
                      <div className={`font-bold leading-tight ${item.highlight ? 'text-white text-xs md:text-sm' : 'text-white text-[11px] md:text-xs'}`} data-id="element-172">
                        {item.title}
                      </div>
                      <div className="text-[10px] md:text-[11px] text-[#9CA3AF] mt-0.5 leading-tight" data-id="element-173">
                        {item.subtitle}
                      </div>
                    </div>
                    <div className="font-heading font-bold flex-shrink-0 text-[#9CA3AF] text-xs md:text-sm line-through decoration-[#DC2626] decoration-2" data-id="element-174">
                      {item.price}
                    </div>
                  </div>)}
              </div>

              {/* Total value + discount badge inline */}
              <div className="flex justify-between items-center py-2 border-t border-[#262626]" data-id="element-175">
                <span className="font-heading text-[#9CA3AF] text-[11px] md:text-xs tracking-widest" data-id="element-176">
                  VALOR TOTAL
                </span>
                <div className="flex items-center gap-2" data-id="element-177">
                  <span className="font-heading text-sm md:text-base font-bold text-[#9CA3AF] line-through decoration-[#DC2626] decoration-2" data-id="element-178">
                    $53.930
                  </span>
                  <div className="inline-flex items-center gap-1 bg-[#DC2626] text-white font-heading font-bold text-[11px] md:text-xs px-2 py-0.5 rounded-sm tracking-wider shadow-lg shadow-[#DC2626]/30" data-id="element-179">
                    <Flame className="w-3 h-3 fill-current" data-id="element-180" />
                    63% OFF
                  </div>
                </div>
              </div>

              {/* Final price */}
              <div className="text-center bg-gradient-to-b from-[#F59E0B]/10 to-transparent border-y border-[#F59E0B]/30 py-4 mb-3 mt-2 relative" data-id="element-181">
                <div className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#F59E0B] text-[#0a0a0a] font-heading font-bold text-[10px] tracking-widest px-2.5 py-0.5 rounded-sm flex items-center gap-1" data-id="element-182">
                  <Crown className="w-2.5 h-2.5" data-id="element-183" />
                  PRECIO HOY
                </div>

                <div className="flex items-baseline justify-center gap-2 mb-1" data-id="element-184">
                  <span className="font-heading text-3xl md:text-5xl font-bold text-white leading-none" data-id="element-185">
                    $19.990
                  </span>
                  <span className="font-heading text-base md:text-lg text-[#F59E0B] font-bold" data-id="element-186">
                    ARS
                  </span>
                </div>
                <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-0.5 text-[10px] md:text-[11px] text-[#9CA3AF] font-medium" data-id="element-187">
                  <span data-id="element-188">Pago único</span>
                  <span className="text-[#262626]" data-id="element-189">•</span>
                  <span data-id="element-190">Acceso inmediato</span>
                  <span className="text-[#262626]" data-id="element-191">•</span>
                  <span data-id="element-192">Descarga digital</span>
                </div>
              </div>

              {/* Urgency line */}
              <div className="text-center mb-3" data-id="element-193">
                <p className="inline-flex items-center gap-1.5 text-[11px] md:text-xs text-[#F59E0B] font-medium" data-id="element-194">
                  <Flame className="w-3 h-3" data-id="element-195" />
                  Precio de lanzamiento — aumenta próximamente
                </p>
              </div>

              {/* CTA Button */}
              <a href="https://ebooksolutions.online/cart/46502134874166:1" target="_top" rel="noopener" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'MegaPack Mecánica Básica',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block w-full text-center bg-[#F59E0B] hover:bg-[#D97706] text-[#0a0a0a] font-heading font-bold text-base md:text-lg px-5 py-3.5 rounded-sm tracking-wider transition-all hover:scale-[1.01] active:scale-[0.99] shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_40px_rgba(245,158,11,0.6)] mb-2.5" data-id="element-196">
                🚀 ¡SÍ! QUIERO EL MEGAPACK{' '}
                <span className="font-sans font-medium text-xs md:text-sm tracking-normal normal-case" data-id="element-197">
                  (compra vía web)
                </span>
              </a>

              {/* WhatsApp purchase button */}
              <a href="https://wa.me/5492613615512?text=Hola%2C%20quisiera%20realizar%20la%20compra%20del%20megapack%20mec%C3%A1nica%20b%C3%A1sica" target="_blank" rel="noopener noreferrer" className="flex w-full items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1EBE57] text-[#0a0a0a] font-heading font-bold text-base md:text-lg px-5 py-3.5 rounded-sm tracking-wider transition-all hover:scale-[1.01] active:scale-[0.99] mb-3" data-id="element-198">
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current flex-shrink-0" aria-hidden="true" data-id="element-199">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-200" />
                </svg>
                COMPRA VÍA WHATSAPP
              </a>

              {/* Trust badges */}
              <div className="grid grid-cols-5 gap-1.5 pt-3 border-t border-[#262626]" data-id="element-201">
                {[{
                icon: Lock,
                label: 'Pago único'
              }, {
                icon: Zap,
                label: 'Inmediato'
              }, {
                icon: ShieldCheck,
                label: 'Garantía 7d'
              }, {
                icon: Smartphone,
                label: 'Multi-disp.'
              }, {
                icon: Download,
                label: 'Descarga'
              }].map((b, i) => {
                const Icon = b.icon;
                return <div key={i} className="flex flex-col items-center text-center gap-0.5" data-id="element-202">
                      <Icon className="w-3.5 h-3.5 text-[#F59E0B]" data-id="element-203" />
                      <span className="text-[8px] md:text-[9px] text-[#9CA3AF] font-medium leading-tight" data-id="element-204">
                        {b.label}
                      </span>
                    </div>;
              })}
              </div>
            </div>
          </div>
        </SectionReveal>
      </div>
    </section>;
}